// extracted by mini-css-extract-plugin
export default {"createToggle":"CreateNewModal_createToggle__QPUmj"};